import React, { Component, useState, useRef } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover,Overlay } from 'react-bootstrap'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
class SelectionTable extends React.Component {
    constructor(props) {
        super(props);


        this.dt = React.createRef();


        this.state = {

            globalSearchBox: '',

            data: this.props.data,
            columns: this.props.columns,
            PageSize:5,
            selectedProducts: ''
        };

        this.onChange = this.onChange.bind(this);
        this.exportCSV=this.exportCSV.bind(this);
        this.saveAsExcelFile=this.saveAsExcelFile.bind(this);
        this.exportExcel=this.exportExcel.bind(this);
        this.onSelectionChange = this.onSelection.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data})
      }
    onChange(e) {
        console.log(e.target.value);
        this.setState(
            { [e.target.name]: e.target.value }
        )

    }

    onSelection(e) {
        console.log(e.value);
        this.setState(
            { selectedProducts: e.value }
        )

    }
    
    exportCSV = () => {
         this.dt.current.exportCSV({ });
    }

    exportPdf = () => {
        const exportColumns = this.state.columns.map(col => ({ title: col.HeaderText, dataKey: col.MappingColomn }));
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, this.state.data);
                doc.save('ExportedFile.pdf');
            })
        })
    }

    exportExcel = () => {
         
        import('xlsx').then(xlsx => {
            let ws = xlsx.utils.json_to_sheet(this.state.data);
            // const worksheet = xlsx.utils.json_to_sheet(this.dt);
            const worksheet = xlsx.utils.json_to_sheet(this.state.data);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, 'ExportedFile');
          }
        );
    }

    saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    render() {
        return (
                <>
               
                 {/* <Card>
                     <Card.Body>
                         <Container> */}
                <div class="d-flex justify-content-between">
                    <div className="btn-group">
                        <Button onClick={this.exportExcel}>Excel</Button>
                        <Button onClick={this.exportPdf}>PDF</Button>
                    </div>
                    <div>
                        <input type="text" className="form-control" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.onChange} />
                    </div>

                </div>
                        <DataTable ref={this.dt} class="Table" value={this.state.data} onSelectionChange={this.onSelectionChange} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} selection={this.state.selectedProducts}  dataKey="id" >
                            
                         <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>


                            {
                                this.state.columns.map(
                                    (item, index) => (
                                        <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>)
                                    )
                            }
                        </DataTable>
                        {/* </Container> 
                      </Card.Body>
                  </Card>*/}
                </>
            
        );
    }
}

export default SelectionTable;


